/* eslint-disable react/button-has-type */
import React, { useRef, useState } from 'react';
import SignaturePad from 'react-signature-canvas';
import SignatureCanvas from 'react-signature-canvas';
import { SignatureForm, SignatureDiv } from './WrapperDiv';
import './style/style.css';

type FormSignatureProps = {
  handleValidate?: (event: any) => void;
  handleClear?: () => void;
  readOnly?: boolean;
  subqchoice: any;
};

export const FormSignature = ({
  handleValidate,
  handleClear,
  readOnly,
  subqchoice,
}: FormSignatureProps) => {
  const [className, setClassName] = useState<string>('sigCanvas');

  const padRef = useRef<SignatureCanvas>(null);

  const clear = () => {
    if (handleClear) {
      setClassName('sigCanvas');
      handleClear();
      return padRef.current?.clear();
    }
    return null;
  };

  const validate = () => {
    if (handleValidate) {
      setClassName('validateCanvas');
      const url = padRef.current?.getTrimmedCanvas().toDataURL('image/png');
      if (url) {
        handleValidate(url);
      }
    }
  };

  const hasSignature =
    typeof subqchoice.value === 'string' &&
    subqchoice.value.indexOf('data:image') === 0;

  const getReadImage = () =>
    hasSignature ? (
      <SignatureDiv>
        <img alt="Signature" src={subqchoice.value} />
      </SignatureDiv>
    ) : (
      <div>No Signature</div>
    );

  const getPad = () => (
    <SignaturePad ref={padRef} canvasProps={{ className }} penColor="#9edbf7" />
  );
  const style = readOnly ? { display: 'none' } : {};

  return (
    <SignatureForm id="signature-form" readOnly={readOnly}>
      <div>{subqchoice.questionlabel}</div>

      {readOnly ? getReadImage() : getPad()}
      <>
        <div id="sig-preview" style={style}>
          <button onClick={validate} disabled={readOnly}>
            Validate
          </button>
          <button onClick={clear} disabled={readOnly}>
            Clear
          </button>
        </div>
      </>
    </SignatureForm>
  );
};
